import { render, staticRenderFns } from "./CoozzyContactMultiselect.vue?vue&type=template&id=8f06bee0&scoped=true"
import script from "./CoozzyContactMultiselect.vue?vue&type=script&lang=js"
export * from "./CoozzyContactMultiselect.vue?vue&type=script&lang=js"
import style0 from "./CoozzyContactMultiselect.vue?vue&type=style&index=0&id=8f06bee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f06bee0",
  null
  
)

export default component.exports